/**
 * Table chrome shared by the Portfolio bets table and the market page's My positions
 * table, so both keep the same row rhythm, column sizing and body typography.
 * Pair it with the `bet-table-header` class on the `<thead>` (see BetRow.scss).
 */
export const BET_TABLE_CLASS =
  'bet-table table-fixed w-full min-w-full border-separate border-spacing-x-0 border-spacing-y-10 relative'
